import React,{useState} from 'react';
import { Box,CircularProgress,IconButton } from '@mui/material';
import { DataGrid,GridColDef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useSpaces } from '../hooks/useSpaces.ts';
import apiService from '../services/apiService.ts';
import GridEmpty from '../components/GridEmpty.tsx';
import SpaceDialog from '../components/SpaceDialog.tsx';

const SpacesPage:React.FC=()=>{
  const [params]=useSearchParams();
  const locationId=params.get('locationId')||'';
  const navigate = useNavigate();
  const { rows,loading,refetch }=useSpaces(locationId);
  const [dialogOpen,setDialogOpen]=useState(false);
  const [editing,setEditing]=useState<any|null>(null);

  const handleDelete=async(id:string)=>{await apiService.deleteSpace(locationId,id);refetch();};

  const cols:GridColDef[]=[
    {field:'id',headerName:'ID',width:80},
    {field:'name',headerName:'Name',flex:1},
    {field:'capacity',headerName:'Capacity',width:120},
    {field:'actions',headerName:'',width:120,renderCell:(p)=>(
      <>
        <IconButton onClick={(event)=>{
          event.stopPropagation();
          setEditing(p.row);
          setDialogOpen(true);
        }}><EditIcon/></IconButton>
        <IconButton onClick={(event)=>{
          event.stopPropagation();
          handleDelete(p.row.id);
        }}><DeleteIcon/></IconButton>
      </>
    )}
  ];

  return(
    <Box p={2}>
      <IconButton color="primary" onClick={()=>{setEditing(null);setDialogOpen(true);}}><AddIcon/></IconButton>
      {loading? <CircularProgress/>:(
        <DataGrid
          rows={rows}
          columns={cols}
          autoHeight
          disableRowSelectionOnClick
          components={{ NoRowsOverlay: GridEmpty }}
          onRowClick={(p)=>{
            const id = p.row.id ?? p.id;
            if(!id) return;
            localStorage.setItem('saSelectedSpace', String(id));
            navigate(`/dashboard/tables?spaceId=${encodeURIComponent(String(id))}`);
          }}
        />
      )}
      <SpaceDialog open={dialogOpen} onClose={()=>setDialogOpen(false)} locationId={locationId} initial={editing} onSaved={refetch}/>
    </Box>
  );
};
export default SpacesPage;
